import React from "react";
import { Redirect } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { deriveRedirectTarget, SETTINGS_ROUTE } from "components/router/Routes";

export const SettingsMainView = () => {
    const isRouteEnabled = useIsRouteEnabled();
    const target = deriveRedirectTarget(SETTINGS_ROUTE, isRouteEnabled);

    return <Redirect to={target.path} />;
};
